import { create } from "zustand";
import axios from "axios";

const contactUsStore = create((set) => ({
  contactUsForm: {
    firstName: "",
    lastName: "",
    email: "",
    phoneNo: "",
    message: "",
  },

  contactUsFormIsError: {
    firstName: false,
    lastName: false,
    email: false,
    emailMessage: "",
    phoneNo: false,
    message: false,
  },

  setContactUsFormIsError: ({ name, value }) => {
    set((state) => {
      return {
        contactUsFormIsError: {
          ...state.contactUsFormIsError,
          [name]: value,
        },
      };
    });
  },

  setContactUsFormIsLoggedIn: ({ firstName, lastName, email, phoneNo }) => {
    set((state) => {
      return {
        contactUsForm: {
          ...state.contactUsForm,
          firstName,
          lastName,
          email,
          phoneNo,
        },
      };
    });
  },

  setContactUsForm: (e) => {
    const { name, value } = e.target;

    set((state) => {
      return {
        contactUsForm: {
          ...state.contactUsForm,
          [name]: value,
        },
      };
    });
  },

  setCleatAll: () => {
    set({
      contactUsForm: {
        firstName: "",
        lastName: "",
        email: "",
        phoneNo: "",
        message: "",
      },

      contactUsFormIsError: {
        firstName: false,
        lastName: false,
        email: false,
        emailMessage: "",
        phoneNo: false,
        message: false,
      },
    });
  },

  createContactUs: async () => {
    try {
      const { contactUsForm, setCleatAll } = contactUsStore.getState();

      const res = await axios.post("/site/create-contact-us", contactUsForm);

      if (res) {
        setCleatAll();
        return true;
      } else {
        return false;
      }
    } catch (error) {
      console.log(error);
      return false;
    }
  },
}));

export default contactUsStore;
